import {
  takeLatest, put, call,
} from 'redux-saga/effects';
import api from 'store/api';
import { toast } from 'react-toastify';
import { URL } from '../../../constants/url';
import actionTypes from '../actionTypes';
import { suitChecker } from '../../../utils/game/suitChecker';
import { setCurrentGameTableRef } from '../actions';
import { sortRawCards } from 'utils/game/sortRandomCards';

export function* setCurrentGameRef({ payload }) {
  const thirdFourChooser = (card3, card4, card5, firstTwoIsPair) => {
    if (!firstTwoIsPair) {
      return ([card3, card4]);
    }

    if (card3 === card4) {
      return ([card3, card4]);
    }

    const arr = sortRawCards([card3, card4, card5]);
    return ([arr[0], arr[1]]);
  };

  const defineEndpoint = (isPlo5, isFreeUser) => {
    if (isPlo5) return URL.PLO5COMBINATION;
    if (isFreeUser) return URL.COMBINATION_FREE;
    return URL.COMBINATION;
  };

  const isPlo5 = sessionStorage.getItem('isPlo5') === 'true';
  const { isFreeUser } = payload;
  const card1 = payload.combo[0][0];
  const card2 = payload.combo[1][0];
  // eslint-disable-next-line max-len
  const arr = isPlo5 ? thirdFourChooser(payload.combo[2][0], payload.combo[3][0], payload.combo[4][0], payload.combo[0][0] === payload.combo[1][0]) : [payload.combo[2][0], payload.combo[3][0]];
  const card3 = arr[0];
  const card4 = arr[1];
  const suit = isPlo5 ? payload.suit : suitChecker(payload.combo);
  const bb = payload.stackSize.value.replace('bb', '');
  const game = payload.gameOption?.value;
  // eslint-disable-next-line no-nested-ternary
  const stakeChooser = () => {
    if (payload.position === 'sbnolimpvsbb') return 'sbnolimp';
    if (payload.position.includes('4bet')) return `${payload.position.slice(0, -4)}`;
    if (payload.position.slice(0, payload.position.length - 4).includes('limp')) return `${payload.position.slice(0, 2)}rfi`;
    if (payload.position.includes('limp')) return payload.position;
    // if (payload.position.length === 10) return `${payload.position.slice(0, 2)}rfi`;
    // if (payload.position.length === 8) return `${payload.position.slice(0, 2)}rfi`;
    if (payload.position.length < 3 && !isPlo5) return `${payload.position}rfi`;
    return payload.position;
  };
  const stake = stakeChooser();
  const ts = payload.limit.value;
  const { ggps } = payload;
  try {
    const res = yield call(api, {
      method: 'post',
      url: defineEndpoint(isPlo5, isFreeUser),
      data: {
        card1,
        card2,
        card3: isPlo5 ? card3 : '',
        card4: isPlo5 ? card4 : '',
        suit,
        bb,
        stake,
        ts,
        game,
        goodsuit: payload.goodSuit,
        gg: ggps === 'gg',
      },
    });
    const { data } = res;
    yield put(setCurrentGameTableRef.success({
      currentGameTableRef: data?.combinations || [],
      highestCard: data?.highest || '',
      legenda: data?.legenda?.colors || [],
      easyLegenda: data?.easy_legenda?.colors || [],
    }));
  } catch (e) {
    yield call(toast.error, e.message);
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.SET_CURRENT_GAME_REF, setCurrentGameRef);
}
